import {IGuide} from '@devrel-stack/api/types';
import analytics from '@devrel-stack/utilities/src/analytics';
import {Categories, Guide} from 'components/ui';
import {useEffect, useState} from 'react';
import {FiArrowDown} from 'react-icons/fi';

interface IProps {
	guides?: IGuide[];
	showInlineAvatars?: boolean;
	showCategories?: boolean;
}

const INITIALLY_VISIBLE_GUIDES = 30;
const GUIDES_PER_PAGE = 10;

export const GuidesGrid = ({
	guides,
	showInlineAvatars = false,
	showCategories = true
}: IProps) => {
	const [visibleGuides, setVisibleGuides] = useState(
		guides?.slice(0, INITIALLY_VISIBLE_GUIDES)
	);

	useEffect(() => {
		setVisibleGuides(guides?.slice(0, INITIALLY_VISIBLE_GUIDES));
	}, [guides]);

	if (!guides) {
		return null;
	}

	const handleLoadMore = () => {
		setVisibleGuides(
			guides?.slice(
				0,
				visibleGuides?.length
					? visibleGuides?.length + GUIDES_PER_PAGE
					: GUIDES_PER_PAGE
			)
		);

		analytics.trackEvent('clicked_load_more', {
			category: 'DevRel',
			app: 'guides'
		});
	};

	const guidesNode = () => {
		if (!visibleGuides) {
			return <h2 tw="font-bold text-xl px-4">No guides found!</h2>;
		}

		return (
			<>
				{visibleGuides.map((guide, index) => {
					return (
						<Guide
							key={guide.id}
							guide={guide}
							position={index}
							showInlineAvatars={showInlineAvatars}
						/>
					);
				})}
			</>
		);
	};

	const categoriesNode = () => {
		if (!showCategories) {
			return null;
		}

		return (
			<div tw="col-span-1 lg:col-span-2">
				<Categories />
			</div>
		);
	};

	return (
		<div tw="bg-transparent">
			<div tw="mx-auto max-w-6xl p-4 space-y-0">
				<div tw="py-16 relative max-w-6xl mx-auto space-y-24">
					<div tw="grid grid-cols-1 lg:grid-cols-7 gap-16">
						<div tw="col-span-1 lg:col-span-5 space-y-16 order-last lg:order-first">
							{guidesNode()}
						</div>
						{categoriesNode()}
					</div>
					{visibleGuides?.length === guides?.length ? null : (
						<div tw="text-center">
							<button
								tw="bg-gradient-to-br hover:bg-gradient-to-r from-green-100 via-blue-100 to-purple-100 dark:from-green-700 dark:via-blue-700 dark:to-purple-700 rounded-full space-x-2 inline-flex flex-row items-center px-8 py-4 text-blue-900 dark:text-white text-sm font-bold hover:text-blue-900 bg-cover select-none"
								onClick={handleLoadMore}
							>
								<span>Load more guides</span>
								<FiArrowDown tw="h-4 w-4" />
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
